import React, { Fragment } from "react";
import { Menu } from "semantic-ui-react";
import {
  NavLink,
  useRouteMatch,
  Switch,
  Route,
  Redirect
} from "react-router-dom";

import ConfigurationGeneral from "./General";
import ConfigurationCampaigns from "./Campaigns";
import ConfigurationRiksProfile from "./RiksProfile";
import SEDConfiguration from "./SEDConfiguration";
import ERPConfiguration from "./ERPConfiguration";
import MailingConfiguration from "./MailingConfiguration";
import SMSConfiguration from "./SMSConfiguration";
import ProviderSignature from "./ProviderSignature";

export const Configuration = () => {
  let { path, url } = useRouteMatch();

  return (
    <Fragment>
      <div className="col-12">
        <div className="row">
          <div className="col-xs-12 col-sm-4 col-md-3">
            <Menu pointing vertical>
              <Menu.Item name="campaigns" as={NavLink} to={`${url}/campaigns`}>
                <i className="fa fa-tags"></i>
                <span style={{ paddingLeft: "10px" }}>Campañas</span>
              </Menu.Item>
              <Menu.Item
                name="risk-profile"
                as={NavLink}
                to={`${url}/risk-profile`}
              >
                <i className="fa fa-eye"></i>{" "}
                <span style={{ paddingLeft: "10px" }}>
                  Configuraci&oacute;n PR
                </span>
              </Menu.Item>
              <Menu.Item
                name="sed-configuration"
                as={NavLink}
                to={`${url}/sed-configuration`}
              >
                <i className="fa fa-info-circle"></i>{" "}
                <span style={{ paddingLeft: "10px" }}>
                  Configuraci&oacute;n SED
                </span>
              </Menu.Item>
              <Menu.Item
                name="erp-configuration"
                as={NavLink}
                to={`${url}/erp-configuration`}
              >
                <i className="fa fa-money"></i>{" "}
                <span style={{ paddingLeft: "10px" }}>
                  Configuraci&oacute;n ERP
                </span>
              </Menu.Item>
              <Menu.Item
                name="mailing-configuration"
                as={NavLink}
                to={`${url}/mailing-configuration`}
              >
                <i className="fa fa-envelope"></i>{" "}
                <span style={{ paddingLeft: "10px" }}>
                  Configuraci&oacute;n Mailing
                </span>
              </Menu.Item>
              <Menu.Item
                name="sms-configuration"
                as={NavLink}
                to={`${url}/sms-configuration`}
              >
                <i className="fa fa-comments"></i>{" "}
                <span style={{ paddingLeft: "10px" }}>
                  Configuraci&oacute;n SMS
                </span>
              </Menu.Item>
              <Menu.Item
                name="signature-configuration"
                as={NavLink}
                to={`${url}/signature-configuration`}
              >
                <i className="fa fa-file-pdf-o"></i>{" "}
                <span style={{ paddingLeft: "10px" }}>
                  Configuraci&oacute;n Firma
                </span>
              </Menu.Item>
            </Menu>
          </div>
          <div className="col-xs-12 col-sm-8 col-md-9">
            <Switch>
              <Redirect exact from={path} to={`${path}/general`} />
              <Route
                path={`${path}/general`}
                component={ConfigurationGeneral}
              />
              <Route
                path={`${path}/campaigns`}
                component={ConfigurationCampaigns}
              />
              <Route
                path={`${path}/risk-profile`}
                component={ConfigurationRiksProfile}
              />
              <Route
                path={`${path}/sed-configuration`}
                component={SEDConfiguration}
              />
              <Route
                path={`${path}/erp-configuration`}
                component={ERPConfiguration}
              />
              <Route
                path={`${path}/mailing-configuration`}
                component={MailingConfiguration}
              />
              <Route
                path={`${path}/sms-configuration`}
                component={SMSConfiguration}
              />
              <Route
                path={`${path}/signature-configuration`}
                component={ProviderSignature}
              />
            </Switch>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
